import { gql } from "@apollo/client";

export const WELCOME_STATE_SYNC = gql`
  mutation Ftue($payload: FtueInput) {
    ftue(payload: $payload)
  }
`;

export const WELCOME_STATE = gql`
  query Ftue {
    ftue {
      hasCompleted
    }
  }
`;
